import React from 'react';

import {
  Grid,
} from '@material-ui/core';

import InputField from '../../common/components/inputField';

import classes from '../../css/getCSS';


const joinEventForm = (props) => {
  return (
    <React.Fragment>
      <blockquote className={classes.profileFormQuote}>
        Please pay the amount specified in the event and <br />
        enter your bank name and transaction number for us to verify.
      </blockquote>
      <br /><br />
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="bank_name"
            config={props.inputs.bank_name}
            changed={event => props.inputChangedHandler(event, 'bank_name')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="transaction_id"
            config={props.inputs.transaction_id}
            changed={event => props.inputChangedHandler(event, 'transaction_id')}
          />
        </Grid>
        <Grid item md={12} xs={12} sm={12}>
          <InputField
            id="date"
            config={props.inputs.date}
            changed={event => props.inputChangedHandler(event, 'date')}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default joinEventForm;



// WEBPACK FOOTER //
// ./src/main/components/JoinEventForm.js